<template lang="pug">
  p.app-calendar-event-card.event-item(
    :class="cssClasses"
    @click="$emit('click', event, $event)"
  )
    slot(
      :event="event"
      v-if="showTitle"
    ) {{ event.title }}
</template>

<script>
import moment from 'moment';

export default {
  name: 'AppCalendarEventCard',
  props: {
    event: {
      type: Object,
      default: () => ({}),
    },
    date: {
      type: Object,
      default: () => ({}),
    },
    firstDay: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    cssClasses() {
      let cssClasses = this.event.cssClass;

      if (!Array.isArray(cssClasses)) cssClasses = [cssClasses];
      else cssClasses = Array.from(cssClasses);

      if (this.start.isSame(this.date, 'day')) cssClasses.push('is-start');
      if (this.end.isSame(this.date, 'day')) cssClasses.push('is-end');
      if (!this.event.isShow) cssClasses.push('is-opacity');

      return cssClasses.join(' ');
    },
    showTitle() {
      return (this.date.day() === this.firstDay || this.start.isSame(this.date, 'day'));
    },
    start() {
      return moment(this.event.start);
    },
    end() {
      return moment(this.event.end);
    },
  },
};
</script>

<style lang="stylus" scoped>
.app-calendar-event
  cursor pointer
  font-size 12px
  background-color #C7E6FD
  margin-bottom 2px
  color rgba(0,0,0,.87)
  padding 0 0 0 4px
  height 18px
  line-height 18px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

  &.is-start
    margin-left 4px

  &.is-end
    margin-right 4px

  &.is-opacity
    opacity 0
</style>
